<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10sIe3s/tc-custom/9780226125985.jpg?1726444214851" alt="This image is the cover for the book Telling About Society"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Telling About Society
      </h1>
      <p class="bookDescription body article font2">
        <i>I Remember</i>, one of French writer Georges Perec’s most famous pieces, consists of 480 numbered paragraphs—each just a few short lines recalling a memory from his childhood. The work has neither a beginning nor an end. Nor does it contain any analysis. But it nonetheless reveals profound truths about French society during the 1940s and 50s.<br/><br/> Taking Perec’s book as its cue, <i>Telling About Society</i> explores the unconventional ways we communicate what we know about society to others. The third in distinguished teacher Howard Becker’s best-selling series of writing guides for social scientists, the book explores the many ways knowledge about society can be shared and interpreted through different forms of telling—fiction, films, photographs, maps, even mathematical models—many of which remain outside the boundaries of conventional social science. Eight case studies, including the photographs of Walker Evans, the plays of George Bernard Shaw, the novels of Jane Austen and Italo Calvino, and the sociology of Erving Goffman, provide convincing support for Becker’s argument: that every way of telling about society is perfect—for some purpose. The trick is, as Becker notes, to discover what purpose is served by doing it <i>this</i> way rather than <i>that.</i><br/> With Becker’s trademark humor and eminently practical advice, <i>Telling About Society</i> is an ideal guide for social scientists in all fields, for artists interested in saying something about society, and for anyone interested in communicating knowledge in unconventional ways.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard S. Becker
      </h2>
      
      <p class="authorDescription body article"><B>Howard Becker</B> lives and works in San Francisco.&#160;He is the author of several books, including <I>Outsiders</I>, <I>Writing for Social Scientists</I>, and <I>Tricks of the Trade</I>, the latter two published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21d997fe